import React, { useEffect, useState } from 'react';

// Bolts radiating from center (50,50) in a 100x100 viewBox
const BURST_BOLTS = [
  'M50 50 L48 30 L54 32 L46 12 L56 16 L48 -8',
  'M50 50 L70 48 L68 54 L88 46 L84 56 L108 48',
  'M50 50 L52 70 L46 68 L54 88 L44 84 L52 108',
  'M50 50 L30 52 L32 46 L12 54 L16 44 L-8 52',
  'M50 50 L66 34 L64 40 L82 22 L78 32 L96 8',
  'M50 50 L34 34 L40 32 L22 14 L32 18 L8 -4',
  'M50 50 L34 66 L32 60 L14 78 L18 68 L-4 92',
  'M50 50 L66 66 L60 68 L78 86 L68 82 L92 104',
];

// Bolt path for top-left corner (origin near 0,0 zigzagging inward)
// Used for all 4 corners via CSS transforms
const CORNER_BOLT_MAIN = 'M10 10 L40 50 L30 45 L70 95 L55 85 L100 145 L80 135 L130 195';
const CORNER_BOLT_BRANCH = 'M40 50 L65 55 L55 65 L90 75 L75 85 L120 95';
const CORNER_BOLT_THIN = 'M30 45 L20 80 L35 70 L25 110 L40 100 L30 140';

const CornerBolts = ({ corner, baseDelay }) => (
  <svg className={`corner-${corner}`} viewBox="0 0 200 280">
    <path d={CORNER_BOLT_MAIN} className="aw-bolt aw-bolt-ambient"
      style={{ animationDelay: `${baseDelay}s` }} />
    <path d={CORNER_BOLT_BRANCH} className="aw-bolt aw-bolt-ambient"
      style={{ animationDelay: `${baseDelay + 0.4}s`, strokeWidth: 1.8 }} />
    <path d={CORNER_BOLT_THIN} className="aw-bolt aw-bolt-ambient"
      style={{ animationDelay: `${baseDelay + 1.1}s`, strokeWidth: 1.5 }} />
  </svg>
);

export const LightningEffect = ({ mode = 'off' }) => {
  // Re-mount the burst overlay whenever a new burst is requested so the
  // CSS animation restarts cleanly even if a previous burst hasn't unmounted.
  const [burstKey, setBurstKey] = useState(0);
  useEffect(() => {
    if (mode === 'burst') setBurstKey(k => k + 1);
  }, [mode]);

  if (mode === 'off') return null;

  if (mode === 'burst') {
    return (
      <div key={burstKey} className="aw-lightning-burst">
        <div className="aw-lightning-flash" />
        <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice">
          {BURST_BOLTS.map((d, i) => (
            <path
              key={i}
              d={d}
              className="aw-bolt aw-bolt-burst"
              style={{ animationDelay: `${i * 0.025}s` }}
            />
          ))}
        </svg>
      </div>
    );
  }

  // ambient
  return (
    <div className="aw-lightning-ambient">
      <div className="aw-ambient-glow glow-tl" />
      <div className="aw-ambient-glow glow-tr" />
      <div className="aw-ambient-glow glow-bl" />
      <div className="aw-ambient-glow glow-br" />
      <CornerBolts corner="tl" baseDelay={0} />
      <CornerBolts corner="tr" baseDelay={1.2} />
      <CornerBolts corner="bl" baseDelay={2.3} />
      <CornerBolts corner="br" baseDelay={3.4} />
    </div>
  );
};

export default LightningEffect;
